import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import ClickOutside from 'react-onclickoutside'
import Symbol from '../../../Symbol'
import classNames from 'classnames'
import UserMenuLinks from '../../../../utils/UserMenuLinks'
import {Wrapper, MenuIcon} from './components/Styled'
import MessengerPopUp from '../MessengerPopUp'

class UserMenuMobile extends Component {
  static defaultProps = {
    isHidden: true,
    isLogged: false,
    user: null,
    menus: [{}],
    icon: '',
    closeIcon: '',

    onLogin: () => {},
    onLogout: () => {}
  }

  static propTypes = {
    accountLinks: PropTypes.object,
    closeIcon: PropTypes.string,
    haveUnreadMessages: PropTypes.bool,
    icon: PropTypes.string,
    isHidden: PropTypes.bool,
    isLogged: PropTypes.bool,
    lastMessage: PropTypes.object,
    login: PropTypes.func,
    logout: PropTypes.func,
    menus: PropTypes.arrayOf(PropTypes.object),
    messengerLink: PropTypes.string,
    signUp: PropTypes.func,
    unreadMessageCount: PropTypes.number,
    user: PropTypes.object,
    userIsBreeder: PropTypes.bool,
    userIsGroomer: PropTypes.bool,
    userIsTrainer: PropTypes.bool,
    onLogin: PropTypes.func,
    onLogout: PropTypes.func
  }

  constructor (props) {
    super(props)

    this.state = {
      isHidden: this.props.isHidden,
      tabOpen: null,
      subTabOpen: null
    }
  }

  handleClickOutside () {
    this.setState({isHidden: true})
  }

  showMenu = () => {
    this.setState({isHidden: !this.state.isHidden})
  }

  renderMenuLink (menuLink) {
    let optionalProps = {}
    if (menuLink.onClick) {
      optionalProps.onClick = menuLink.onClick
    }
    return (
      <li key={menuLink.title} className='accordion-menu__list-control'>
        <a className={`accordion-menu__link accordion-menu__text-link ${menuLink.icon && 'accordion-menu__link-with-image'}`} href={menuLink.url} {...optionalProps}>
          {menuLink.unread && <span className={`${menuLink.unread ? '' : '--hide'}`} />}
          {menuLink.title} {this.props.unreadMessageCount && menuLink.title.includes('Messenger') ? <span className='header-unread-count__menu' > {this.props.unreadMessageCount} </span> : ''}
        </a>
      </li>
    )
  }

  getUserProfileLinks () {
    let menuLinks = new UserMenuLinks(
      this.props.accountLinks,
      this.props.onLogout,
      this.props.haveUnreadMessages,
      this.props.messengerLink,
      this.props.userIsBreeder,
      this.props.userIsGroomer,
      this.props.userIsTrainer
    ).getUserMenu()

    return (
      <ul className='accordion accordion-menu__list pl0 pr0'>
        {
          menuLinks.map(menuLink => {
            return this.renderMenuLink(menuLink)
          })
        }
      </ul>
    )
  }

  getUserThumbnail () {
    if (this.props.user.profile_thumbnail && this.props.user.profile_thumnail !== '') {
      return <img height='38px' src={this.props.user.profile_thumbnail} style={{borderRadius: '50%'}} width='38px' />
    }

    return <Symbol className='icon icon-profile' height='38' name='icon-profile' width='38' />
  }

  render () {
    if (this.props.isLogged) {
      return (
        <Wrapper>
          {this.props.lastMessage &&
          <MessengerPopUp
            messageObject={this.props.lastMessage}
            redirectTo={this.props.accountLinks.messenger}
          />
          }
          <MenuIcon onClick={this.showMenu}>
            <div>
              {this.getUserThumbnail()}
              {this.props.unreadMessageCount ? <span className='header-unread-count' > {this.props.unreadMessageCount} </span> : ''}
            </div>
          </MenuIcon>
          <div className='slim-header__dropdowns'>
            <div
              className={classNames(
                'site-menu',
                {'is-open': !this.state.isHidden},
                'site-menu--user'
              )}
              style={this.state.isHidden ? {visibility: 'hidden'} : null}
            >
              <nav className='accordion-menu'>
                {this.getUserProfileLinks()}
              </nav>
            </div>
          </div>
        </Wrapper>
      )
    }
    return (
      <Wrapper>
        <MenuIcon onClick={this.props.onLogin}>
          <span>SIGN IN</span>
          <Symbol className='icon icon-menu' name='icon-akc-user'/>
        </MenuIcon>
      </Wrapper>
    )
  }
}

const mapStateToProps = state => {
  return {
    isLogged: state.app.isLogged,
    user: state.app.user,
    haveUnreadMessages: state.app.have_unread_messages,
    lastMessage: state.app.lastMessage ? state.app.lastMessage : null,
    messengerLink: state.app.messenger_link,
    accountLinks: state.app.account_links,
    userIsBreeder: state.app.user_is_breeder,
    userIsGroomer: state.app.user_is_groomer,
    userIsTrainer: state.app.user_is_trainer,
    cms: state.app.cms
  }
}

export default connect(mapStateToProps, {})(ClickOutside(UserMenuMobile))
